module.exports = __webpack_public_path__ + "img/MaestroLogoDark.c0f4e23d.svg";